import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Check if navigation was triggered by popstate (back/forward buttons)
    if (!window.history.state?.scroll) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  // Listen for popstate events (back/forward navigation)
  useEffect(() => {
    const handlePopState = () => {
      // Don't scroll on back/forward navigation
      window.history.state.scroll = true;
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return null;
} 